module.exports = __webpack_public_path__ + "img/NSIA-Banque.a6824dc2.jpg";